import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import { decodeDataToken, getToken } from "../../../../../helpers/token/refreshToken";
import { getEnterpriseRatesBase } from "../../data/entepriseApi";
import {
  hasCoordinates,
  normalizeAddress,
  toLatLngLiteral,
} from "../helpers/addressRouteHelpers";

let googleMapsOptionsConfigured = false;

const getGoogleMapsRoutesLibrary = async ({ apiKey, language, region }) => {
  if (!apiKey) {
    throw new Error("NO SE ENCONTRO LA API KEY DE GOOGLE MAPS");
  }

  if (!googleMapsOptionsConfigured) {
    setOptions({
      key: apiKey,
      language,
      region,
    });
    googleMapsOptionsConfigured = true;
  }

  return importLibrary("routes");
};

const requestDirections = async ({ addressOrigin, destination, waypoints }) => {
  // 
  //process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  const { DirectionsService } = await getGoogleMapsRoutesLibrary({
    apiKey: "AIzaSyBIbtiiqiEJ6F2ScRafjfv1SmpaeWg3NDQ",
    language: "es",
    region: "PE",
  });
  const directionsService = new DirectionsService();

  return new Promise((resolve, reject) => {
    directionsService.route(
      {
        origin: toLatLngLiteral(addressOrigin),
        destination: toLatLngLiteral(destination),
        waypoints,
        travelMode: window.google?.maps?.TravelMode?.DRIVING ?? "DRIVING",
        optimizeWaypoints: false,
      },
      (response, status) => {
        if (status === "OK" && response) {
          resolve(response);
          return;
        }

        reject(new Error(`GOOGLE MAPS DIRECTIONS STATUS: ${status}`));
      },
    );
  });
};

const roundPriceToFixedAmount = (price) => {
  const numericPrice = Number(price);

  if (!Number.isFinite(numericPrice)) {
    return 0;
  }

  return Math.ceil(numericPrice);
};

export const calculateEnterpriseRoutePricing = async ({
  addressOrigin,
  subRoutesList,
}) => {
  if (!hasCoordinates(addressOrigin) || subRoutesList.length === 0) {
    return null;
  }

  const normalizedSubRoutes = subRoutesList.map(normalizeAddress);
  const destination = normalizedSubRoutes[normalizedSubRoutes.length - 1];

  if (!hasCoordinates(destination)) {
    return null;
  }

  const waypoints = normalizedSubRoutes.slice(0, -1).map((route) => ({
    location: toLatLngLiteral(route),
    stopover: true,
  }));

  const result = await requestDirections({
    addressOrigin,
    destination,
    waypoints,
  });

  const legs = result.routes?.[0]?.legs ?? [];
  const distanceMeters = legs.reduce(
    (total, leg) => total + (leg.distance?.value ?? 0),
    0,
  );
  const durationSeconds = legs.reduce(
    (total, leg) => total + (leg.duration?.value ?? 0),
    0,
  );

  const dataToken = getToken("dttkn");
  const token = decodeDataToken(dataToken);
  const responseRates = await getEnterpriseRatesBase(token.enterprise_id);
  const dataRates = responseRates.data.data;

  const distanceKm = Number((distanceMeters / 1000).toFixed(2));
  const durationMin = Math.ceil(durationSeconds / 60);
  const priceDistance = dataRates.priceDistance * (distanceMeters / 1000);
  const priceDuration = dataRates.priceDuration * (durationSeconds / 60);
  const total = dataRates.priceBase + priceDistance + priceDuration;

  return {
    distanceKm,
    durationMin,
    total: roundPriceToFixedAmount(total),
  };
};
